import React from "react";
import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards, { ServiceCardItem } from "@/components/service/ServiceCards";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import GetAFreeFasciasQuote from "./sections/GetAFreeFasciasQuote";
import { House, Wind, CloudRain, ArrowDownToLine, Sparkles, Wrench } from "lucide-react";
const subServices: ServiceCardItem[] = [{
  title: "uPVC Fascias",
  description: "Durable fascias installation and replacement across Southampton, protecting rafters against coastal weather.",
  icon: House,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/fascias_service.png",
  imageAlt: "uPVC fascias installation on a Southampton home"
}, {
  title: "Ventilated Soffits",
  description: "Proper roof ventilation and clean eaves lines for Southampton properties to stop condensation and damp.",
  icon: Wind,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/soffits_service.png",
  imageAlt: "Ventilated soffits installation in Southampton"
}, {
  title: "Guttering Systems",
  description: "High-capacity seamless and sectional guttering designed for heavy South Coast rainfall and efficient drainage.",
  icon: CloudRain,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/guttering_service.png",
  imageAlt: "Rainwater guttering systems on a property in Southampton"
}, {
  title: "Downpipes & Drainage",
  description: "Reliable rainwater diversion and downpipe installation preventing exterior damp and foundation pooling.",
  icon: ArrowDownToLine,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/downpipes_service.png",
  imageAlt: "Downpipe water diversion installation in Southampton"
}, {
  title: "Gutter Cleaning & Clearing",
  description: "Complete moss, leaf, and silt clearance to protect Southampton gutters from overflowing and seasonal blockages.",
  icon: Sparkles,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/gutter_cleaning_service.png",
  imageAlt: "Professional gutter cleaning and clearing in Southampton"
}, {
  title: "Roofline Repairs & Upgrades",
  description: "Fast leak fixes, bracket realignments, and timber-to-uPVC conversions by experienced Southampton roofers.",
  icon: Wrench,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/repairs_maintenance_service.png",
  imageAlt: "Roofline repairs and guttering maintenance in Southampton"
}];
export default function FasciasGutteringServicesPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Fascias, Soffits & Gutters" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Fascias, Soffits & Gutters in Southampton" intro="Protect your home with professional fascias, soffits, and guttering solutions designed to last. Expert installation, repairs, and maintenance serving Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/fascias_guttering_hero.png" imageAlt="Fascias, soffits, and guttering installation in Southampton" actions={true} />

      <ServiceIntro eyebrow="EXPERT ROOFLINE SOLUTIONS" heading="Reliable Roofline & Guttering Services in Southampton" paragraphs={[<p key="1">
            Looking for expert fascias, soffits, and guttering in Southampton? Firststop Roofing Ltd provides high-performance roofline installations, precision repairs, and seasonal gutter clearing across Southampton, Hampshire &amp; surrounding areas to keep your property protected from water damage.
          </p>, <p key="2">
            As experienced roofers in Southampton, we replace decaying timber boards with durable, low-maintenance uPVC systems. Our seamless guttering and ventilated soffits guard against water ingress, prevent damp rot in your roof timbers, and keep your home looking clean and well maintained year-round.
          </p>]} benefits={["Robust weather protection & damp prevention", "Enhanced roof ventilation & exterior aesthetics", "Low-maintenance, durable uPVC installations"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/new-facias-soffits-gutters.jpg?v=0io3fig2tp" imageAlt="New uPVC fascias, soffits, and gutters fitted in Southampton" cta={true} />

      <ServiceCards eyebrow="OUR SERVICES" heading="Fascias, Soffits & Guttering Solutions in Southampton" intro="Comprehensive roofline installations and gutter repairs by local Southampton roofing specialists to safeguard your roof timbers and foundations." items={subServices} columns={3} />

      <ServiceQuoteSection id="quote-form" eyebrow="GET A FREE QUOTE" heading="Get a Free Roofline Quote in Southampton" intro="Tell us about your fascias, soffits, or guttering requirements and our Southampton team will provide a clear, no-obligation quote within 24 hours." serviceName="Fascias & Guttering">
        <GetAFreeFasciasQuote />
      </ServiceQuoteSection>

      <OtherServices currentKey="fascias-guttering" count={4} />

      <CtaBand />

      <Footer />
    </div>;
}